import LoginPage from 'components/LoginPage';
import UserLoginImageContainer from 'components/UserLoginImageContainer';
import i18n from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import { history } from 'store';
import DeviceValidationForm from './DeviceValidationForm';

interface Props {
  token?: string;
  config: any;
  shouldUpdatePlugin: boolean;
}

const DeviceValidation: React.FC<Props> = ({
  token,
  config,
  shouldUpdatePlugin,
}) => {
  React.useEffect(() => {
    if (!token) history.push('/');
  }, [token, shouldUpdatePlugin]);

  const language = i18n.language || 'pt-BR';

  const descriptionText =
    {
      es: config?.descriptionMfaTextEs,
      'en-US': config?.descriptionMfaTextEn,
      'pt-BR': config?.descriptionMfaTextPtBr,
    }[language] || config?.descriptionMfaTextPtBr;

  const headerText =
    {
      es: config?.headerMfaTextEs,
      'en-US': config?.headerMfaTextEn,
      'pt-BR': config?.headerMfaTextPtBr,
    }[language] || config?.headerMfaTextPtBr;

  return (
    <LoginPage
      imageWrapper={
        <UserLoginImageContainer
          bgImage={config?.imageUrl}
          description={descriptionText}
          header={headerText}
          imageColor={config?.imageLoginBackgroundColor}
          isMfaPage
        />
      }
      logoUrl={config?.logoUrl}
      logoBackgroundColor={config?.logoBackgroundColor}
    >
      <DeviceValidationForm />
    </LoginPage>
  );
};

const mapStateToProps = ({ auth, config }) => ({
  token: auth.isAuthenticate?.access_token,
  config,
  shouldUpdatePlugin: auth.shouldUpdatePlugin,
});

export default connect(mapStateToProps, {})(DeviceValidation);
